import React from 'react'
import Layout from "../../components/Layout"

export default function projectsIndex() {
  return (
      <Layout>
          <div>
              <h1>Ainda não há nada aqui :(</h1>
          </div>
      </Layout>
  )
}
